import * as React from 'react';
import MapDataLoader from '../../services/MapDataLoader';
import Map from '../Map/Map';
import Header from '../Header/Header';
import { useTheme } from '../../../../theme';
import SimpleLoader from '../../../../SimpleLoader';
import { initI18n } from '../../../../utils';
import { useSelector } from 'react-redux';
import { getIsLoading } from '../../store/flightStatus/selectors';
initI18n('FlightStatus');
const FlightStatus = () => {
    const { FlightStatus: css } = useTheme('FlightStatus');
    const isLoading = useSelector(getIsLoading);
    return (React.createElement(React.Fragment, null,
        React.createElement(MapDataLoader, null),
        isLoading && React.createElement(SimpleLoader, null),
        React.createElement(Header, null),
        React.createElement(Map, { className: css.map })));
};
export default FlightStatus;
